import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import EditIMPCSelectionFormContainer from '../containers/EditIMPCSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class EditIMPCSelectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
    };
  }

  onSubmitSaveSelection = ({ name }) => {
    const condition = this.props.selections.map(sel => sel.name).includes(name !== undefined ? name.trim() : '');
    if (condition) {
      this.setState({
        error: 'app.admin.edit.preset.warning.message',
      });
    } else {
      this.props.saveSelection({
        name,
        checkedMailProcessingCenters: this.props.checkedMailProcessingCenters,
      });
    }
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.edit.impc.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <EditIMPCSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          errorMessage={this.state.error}
          selections={this.props.selections}
          checkedMailProcessingCenters={this.props.checkedMailProcessingCenters}
          name={this.props.name}
        />
      </Modal>
    );
  }
}

EditIMPCSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    impcCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string,
};

export default EditIMPCSelectionModal;
